import uiCard from './default/index.vue'
import uiCardToggle from './toggle/index.vue'
import uiCardToggleFilter from './filter/index.vue'

import uiCardAccordionBody from './accordion/body/index.vue'
import uiCardAccordionItem from './accordion/item/index.vue'

import uiCardTabMain from './tabs/main/index.vue'
import uiCardTabButton from './tabs/buttons/index.vue'
import uiCardTabContent from './tabs/content/index.vue'

import uiImageCard from './image'

export {
    uiCard,
    uiCardToggle,
    uiCardAccordionBody,
    uiCardAccordionItem,
    uiCardTabMain,
    uiCardTabButton,
    uiCardTabContent,
    uiCardToggleFilter,
    uiImageCard
}